import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

import { app, firestore } from "../../configs/firebaseConfig";
import {
  notificacionError,
  notificacionAdvertencia,
} from "../../layout/components/content/notifications";
import { authErrorMessage } from "../../utils/authErrorMessage";
import * as userTypes from "./userTypes";

const loadKind = async (email) => {
  const q = query(
    collection(firestore, "users"),
    where("email", "==", email)
  );
  const snaps = await getDocs(q);
  if (snaps.empty) {
    return [""];
  }
  const userData = snaps.docs[0].data();
  return [userData.kind];
};

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch({ type: userTypes.LOADING });
    const auth = getAuth(app);

    let userCredential;
    try {
      userCredential = await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      notificacionError(
        "No se pudo iniciar sesión",
        authErrorMessage(error),
        0
      );
      dispatch({ type: userTypes.LOGIN_FAILURE });
      return;
    }

    const { user } = userCredential;

    // Gate: bloquear hasta verificar el correo. Aquí aún tenemos sesión, así
    // que solicitamos el reenvío del enlace (correo Postmark vía CF) antes de
    // salir.
    if (!user.emailVerified) {
      try {
        await addDoc(collection(firestore, "mailRequests"), {
          type: "verify",
          email: user.email,
          createdAt: serverTimestamp(),
        });
      } catch (e) {
        // Si falla la escritura igual bloqueamos el login.
      }
      await signOut(auth);
      notificacionAdvertencia(
        "Verifica tu correo",
        "Tu correo aún no está verificado. Te reenviamos el enlace. (Revisa también tu carpeta de SPAM).",
        0
      );
      dispatch({ type: userTypes.LOGIN_FAILURE });
      return;
    }

    const { displayName, email: userEmail, emailVerified, uid } = user;
    const roles = await loadKind(userEmail);
    dispatch({
      type: userTypes.LOGIN_SUCCESS,
      payload: { displayName, email: userEmail, emailVerified, uid, roles },
    });
  };
};

export const logout = () => {
  return async (dispatch) => {
    const auth = getAuth(app);
    await signOut(auth).catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log("LOGOUT", { errorCode, errorMessage });
    });
    dispatch({
      type: userTypes.LOGOUT,
    });
  };
};

// De-autoriza en Redux SIN cerrar la sesión de Firebase.
// Lo usa el listener de App.jsx para no correr contra el setDoc del registro.
export const deauthorize = () => ({ type: userTypes.LOGOUT });

export const currentUser = (userData) => {
  return async (dispatch) => {
    dispatch({
      type: userTypes.LOADING,
    });

    const roles = await loadKind(userData.email);
    dispatch({
      type: userTypes.CURRENT,
      payload: {
        ...userData,
        roles,
      },
    });
  };
};

